import React, { useEffect, useState } from "react";
import {
  Redirect,
  Route,
  Switch,
  useRouteMatch,
  useLocation,
} from "react-router-dom";
import { Auth } from "shared/@auth/Auth";
import Page, { Content, Nav, NavGroup, NavItem } from "shared/Page";
import { ReactComponent as Dashboard } from "./assets/Menu_Icon_Dashboard.svg";
import { ReactComponent as Calendar } from "./assets/Menu_Icon_Calendar.svg";
import { ReactComponent as Agenda } from "./assets/Menu_Icon_Agenda.svg";
import { ReactComponent as Decisions } from "./assets/Menu_Icon_Decisions.svg";
import { ReactComponent as Documents } from "./assets/Menu_Icon_Documents.svg";
import { ReactComponent as Summaries } from "./assets/Menu_Icon_Summaries.svg";
import { ReactComponent as ActionItems } from "./assets/Menu_Icon_Action_Items.svg";
import { ReactComponent as Committees } from "./assets/Menu_Icon_Committees.svg";
import { ReactComponent as Projects } from "./assets/Menu_Icon_Projects.svg";
import { ReactComponent as Settings } from "./assets/Menu_Icon_Settings.svg";
import { useCurrentRoute } from "../ExecutiveCommittee/useCurrentRoute.js";

import { DashboardPage } from "./DashboardPage/DashboardPage";
import { CalendarPage } from "./CalendarPage/CalendarPage";
import { AgendaPage } from "./AgendaPage/AgendaPage";
import { DecisionsPage } from "./DecisionsPage/DecisionsPage";
import { DocumentsPage } from "./DocumentsPage/DocumentsPage";
import { SummariesPage } from "./SummariesPage/SummariesPage";
import { ActionItemsPage } from "./ActionItemsPage/ActionItemsPage";
import { CommitteesPage } from "./CommitteesPage/CommitteesPage";
import { ProjectsPage } from "./ProjectsPage/ProjectsPage";
import { SettingsPage } from "./SettingsPage/SettingsPage";

import { Dashboard as DashboardState } from "./DashboardPage/useDashboard";
import { useDocuments } from "./DocumentsPage/useDocuments";

export function ManagementTeam({ isNewSubmitted, isHideInfo, setToggleInfo }) {
  const { path } = useRouteMatch();
  const { hasPermission } = Auth.useContainer();
  const { setCurrentRoute } = useCurrentRoute();
  const { reviewRefetch } = useDocuments();
  const location = useLocation();

  useEffect(() => {
    setCurrentRoute("/management-team");
    return () => {
      setCurrentRoute("");
    };
  });
  // icon colors
  const styles = (pathname) => {
    return {
      filter: !location.pathname.includes(pathname)
        ? "var(--icon-filter)"
        : "var(--icon-filter-invert",
    };
  };

  return (
    <Page>
      <DashboardState.Provider>
        <Nav>
          <NavGroup title="Management Team">
            {hasPermission("management-team.*") && (
              <NavItem
                to={`${path}/dashboard`}
                icon={<Dashboard style={styles("dashboard")} />}
              >
                Dashboard
              </NavItem>
            )}

            {hasPermission("management-team.*") && (
              <NavItem
                to={`${path}/calendar`}
                icon={<Calendar style={styles("calendar")} />}
              >
                Calendar
              </NavItem>
            )}

            {hasPermission("management-team.*") && (
              <NavItem
                to={`${path}/agenda`}
                icon={<Agenda style={styles("agenda")} />}
                notification={isNewSubmitted}
              >
                Agenda{" "}
                {isNewSubmitted > 0 && (
                  <span
                    style={{
                      borderRadius: "50%",
                      border: "1px solid white",
                      background: "#ED1F24 0% 0% no-repeat padding-box",
                      color: "white",
                      width: "20px",
                      height: "20px",
                      textAlign: "center",
                      display: "inline-block",
                      fontSize: "12px",
                    }}
                  >
                    {isNewSubmitted}
                  </span>
                )}
              </NavItem>
            )}

            {hasPermission("management-team.*") && (
              <NavItem
                to={`${path}/decisions`}
                icon={<Decisions style={styles("decisions")} />}
              >
                Decisions
              </NavItem>
            )}

            {hasPermission("management-team.*") && (
              <NavItem
                to={`${path}/documents`}
                icon={<Documents style={styles("documents")} />}
                onClick={() => {
                  reviewRefetch();
                }}
              >
                Documents
              </NavItem>
            )}

            {hasPermission("management-team.*") && (
              <NavItem
                to={`${path}/summaries`}
                icon={<Summaries style={styles("summaries")} />}
              >
                Summaries
              </NavItem>
            )}

            {hasPermission("management-team.*") && (
              <NavItem
                to={`${path}/action-items`}
                icon={<ActionItems style={styles("action-items")} />}
              >
                Action Items
              </NavItem>
            )}

            {hasPermission("management-team.*") && (
              <NavItem
                to={`${path}/committees`}
                icon={<Committees style={styles("committees")} />}
              >
                Committees
              </NavItem>
            )}

            {hasPermission("management-team.*") && (
              <NavItem
                to={`${path}/projects`}
                icon={<Projects style={styles("projects")} />}
              >
                Projects
              </NavItem>
            )}

            {hasPermission("management-team.*") && (
              <NavItem
                to={`${path}/settings`}
                icon={<Settings style={styles("settings")} />}
              >
                Settings
              </NavItem>
            )}
          </NavGroup>
        </Nav>
        <Content>
          <Switch>
            {hasPermission("management-team.*") && (
              <Route path={`${path}/dashboard`}>
                <DashboardPage
                  meetingType="MT"
                  isHideInfo={isHideInfo}
                  setToggleInfo={setToggleInfo}
                />
              </Route>
            )}

            {hasPermission("management-team.*") && (
              <Route path={`${path}/calendar`}>
                <CalendarPage meetingType="MT" />
              </Route>
            )}

            {hasPermission("management-team.*") && (
              <Route path={`${path}/agenda`}>
                <AgendaPage
                  meetingType="MT"
                  isNewSubmitted={isNewSubmitted}
                  isHideInfo={isHideInfo}
                  setToggleInfo={setToggleInfo}
                />
              </Route>
            )}

            {hasPermission("management-team.*") && (
              <Route path={`${path}/decisions`}>
                <DecisionsPage
                  meetingType="MT"
                  isHideInfo={isHideInfo}
                  setToggleInfo={setToggleInfo}
                />
              </Route>
            )}

            {hasPermission("management-team.*") && (
              <Route path={`${path}/documents`}>
                <DocumentsPage
                  meetingType="MT"
                  isHideInfo={isHideInfo}
                  setToggleInfo={setToggleInfo}
                />
              </Route>
            )}

            {hasPermission("management-team.*") && (
              <Route path={`${path}/summaries`}>
                <SummariesPage meetingType="MT" />
              </Route>
            )}

            {hasPermission("management-team.*") && (
              <Route path={`${path}/action-items`}>
                <ActionItemsPage meetingType="MT" />
              </Route>
            )}

            {hasPermission("management-team.*") && (
              <Route path={`${path}/committees`}>
                <CommitteesPage />
              </Route>
            )}

            {hasPermission("management-team.*") && (
              <Route path={`${path}/projects`}>
                <ProjectsPage meetingType="MT" />
              </Route>
            )}

            {hasPermission("management-team.*") && (
              <Route path={`${path}/settings`}>
                <SettingsPage
                  isHideInfo={isHideInfo}
                  setToggleInfo={setToggleInfo}
                />
              </Route>
            )}

            {hasPermission("management-team.*") && (
              <Route path="*">
                <Redirect to={`${path}/dashboard`} />
              </Route>
            )}
          </Switch>
        </Content>
      </DashboardState.Provider>
    </Page>
  );
}
